import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeActivityService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeActivityCreateDto,
  ContractTypeActivityDto,
  ContractTypeActivityExcelDownloadDto,
  ContractTypeActivityUpdateDto,
} from '../proxy/controlling/dtos/contract-type-activity';
import { CONTRACTTYPEACTIVITY_CONFIG, CONTRACTTYPEACTIVITY_FIELDS } from './contract-type-activity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-activity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeActivityService, ConfirmationService],
  templateUrl: './contract-type-activity.html',
  styleUrl: './contract-type-activity.scss',
})
export class ContractTypeActivity extends BaseHierarchicalCrudComponent<
  ContractTypeActivityDto,
  ContractTypeActivityCreateDto,
  ContractTypeActivityUpdateDto,
  ContractTypeActivityExcelDownloadDto
> {
  service = inject(ContractTypeActivityService);
  config = CONTRACTTYPEACTIVITY_CONFIG;
  fields = CONTRACTTYPEACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeActivityDto): ContractTypeActivityUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeActivity';
  }
}
